import React from "react";
import { Link, useLocation } from "react-router-dom";

import { useAppNavigationGuard } from "../contexts/AppNavigationGuardContext";
import { useReportCenter } from "../contexts/ReportCenterContext";
import { resolveAppHeaderConfig, resolveRouteStateReturnTo } from "../lib/appHeaderRoutes";
import { resolvePlansReturnPath } from "../lib/plansNavigation";
import { readPendingReceiptJobSnapshot, resolveReceiptReturnTo } from "../lib/receipt";
import { AppHeaderFrame } from "./AppHeaderFrame";
import { ReportButton } from "./ReportButton";

export function GlobalAppHeader() {
  const location = useLocation();
  const config = resolveAppHeaderConfig(location.pathname);
  const { canNavigate } = useAppNavigationGuard();
  const { isEnabled, unseenCount, isOpen, openReports } = useReportCenter();
  if (!config || !isEnabled) return null;

  const backTo = config.backSource === "receipt"
    ? resolveReceiptReturnTo({
        routeState: location.state,
        pendingSnapshot: readPendingReceiptJobSnapshot(),
        fallback: config.backTo,
      })
    : config.backSource === "plans"
      ? resolvePlansReturnPath(
          (location.state as { from?: unknown; returnTo?: unknown } | null) ?? null,
          true,
          location.search
        )
      : config.backSource === "route-state"
        ? resolveRouteStateReturnTo(location.state, config.backTo)
        : config.backTo;

  return (
    <AppHeaderFrame
      maxWidthClassName="max-w-none"
      left={(
        <Link
          to={backTo}
          replace={config.backReplace}
          aria-label={config.backLabel}
          onClick={(event) => {
            if (!canNavigate()) event.preventDefault();
          }}
          className="inline-flex min-h-11 items-center rounded-full px-2 text-sm font-black text-[#7C5A4E] hover:bg-white/70"
        >
          ← 戻る
        </Link>
      )}
      right={(
        <>
          <ReportButton unseenCount={unseenCount} isOpen={isOpen} onClick={openReports} compact />
          <Link
            to="/home"
            onClick={(event) => {
              if (!canNavigate()) event.preventDefault();
            }}
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-[#EADBC8] bg-white/80 px-3 text-sm font-black text-[#7C5A4E] shadow-sm"
          >
            ホーム
          </Link>
        </>
      )}
    />
  );
}
